// Vollbild-Einblendung quer über die Bildmitte — für Ankündigungen.
// Wird in alle 5 Projektor-Ansichten eingebunden.
// Rendert nur, wenn sichtbar=true und text gesetzt.
export default function Bauchbinde({ text, sichtbar }) {
  if (!sichtbar || !text || !text.trim()) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999, pointerEvents: "none",
    }}>
      <div style={{
        background: "rgba(13,27,42,0.92)",
        borderTop: "4px solid #cc0000",
        borderBottom: "4px solid #cc0000",
        width: "100%", padding: "48px 64px",
        textAlign: "center",
      }}>
        <div style={{
          color: "white", fontSize: 56, fontWeight: 800,
          fontFamily: "Arial, sans-serif", lineHeight: 1.25,
          textShadow: "0 2px 12px rgba(0,0,0,0.6)",
        }}>
          {text}
        </div>
      </div>
    </div>
  );
}
